import axios from 'axios';
import { ApiService } from '../../../../../shared/service/Apiservice';
import { environment } from '../../../../../shared/enviroment/environment';
import { CartConfig, CartConfigApiResponse } from '../dto/cart-config.dto';

export class CartConfigService {
  private apiRootServer = environment.api.apiRootServer;
  private __ApiService: ApiService;

  constructor() {
    const axiosInstance = axios.create();
    this.__ApiService = new ApiService(axiosInstance, this.apiRootServer);
  }

  async getCartConfig(): Promise<CartConfig | null> {
    try {
      const response = await this.__ApiService.getRequest('config', {
        apiRoot: this.apiRootServer,
      }) as CartConfigApiResponse;

      if (response?.success && response?.data) {
        return response.data as CartConfig;
      }
      return null;
    } catch (error) {
      console.error('Error fetching cart config:', error);
      return null;
    }
  }
}

export default CartConfigService;
